import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'identifier',
})
export class IdentifierPipe implements PipeTransform {
  public transform(value: string): any {
    if (!value) {
      return '';
    }
    if (value.length <= 4) {
      return value;
    }
    let prefix: string = '';
    for (let i = 0; i < value.length - 4; i++) {
      prefix += '*';
    }

    return prefix + value.slice(value.length - 4, value.length);
  }
}
